import { render, staticRenderFns } from "./RevenueAnalysisPage.vue?vue&type=template&id=028aa1c9&scoped=true"
import script from "./RevenueAnalysisPage.vue?vue&type=script&lang=js"
export * from "./RevenueAnalysisPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028aa1c9",
  null
  
)

export default component.exports